import { CaptionStyles, CaptionLineConfig, HighlightTypeEnum } from '../../types/asset-types';
import { getFontFullPath } from '../../utils/fontUtils';
import { TransitionInEffect } from '../../types/transitions';

const beast: Partial<CaptionStyles> = {
  theme_preset: 'beast',
  pageStyle: {
    WebkitTextStrokeWidth: '8px',
    WebkitTextStrokeColor: '#000000',
    paintOrder: 'stroke',
    color: '#ffffff'
  },
  wordStyle: {
    active: {
      color: '#07f82c'
    },
    inactive: {
      color: '#ffffff'
    },
    highlightType: HighlightTypeEnum.Text
  },
  letterStyle: undefined,
  font_location: getFontFullPath('KOMIKAX.ttf'),
  caps: false,
  font_size: 102,
  line_config: CaptionLineConfig.OneLine,
  transitions: {
    wordIn: TransitionInEffect.Spring
  }
};

export default beast;
